import React from "react";
import { Route, Switch } from "react-router-dom";

import * as QueriesQL from "queries/site-pack";
import SitePackPublicSchema from "@common/schema/site-pack/public";
import * as Section from "@repoflow/components/section";
import { Crumb } from "@repoflow/components/breadcrumb";

import * as ViewRoute from "./view";
import * as EditRoute from "./edit";
import * as RemoveRoute from "./remove";

const LocalProvider = ({
  match: {
    params,
    params: { packId },
  },
  children: Children,
}) => {
  const { base: parentBase, basepath: parentBasepath } =
    Section.useSectionContext();

  const base = `${parentBase}/${packId}`;
  const basepath = `${parentBasepath}/:packId`;

  // Keyed on the entity, for the reason recorded in ../../sections/section:
  // the screens below seed their form state once, and the remount that used to
  // reset them when you moved between entities is no longer free.
  return (
    <Section.Provider
      key={packId}
      schema={SitePackPublicSchema}
      base={base}
      basepath={basepath}
      attributes={params}
    >
      {/* Called, never rendered as an element — see Section.Provider. */}
      {Children({ base, basepath, params })}
    </Section.Provider>
  );
};

export function Content(props) {
  return (
    <LocalProvider {...props}>
      {({ params }) => (
        <Section.Query
          query={QueriesQL.get}
          variables={params}
          datapath={"sites.get.packs.get"}
        >
          {ContentHandler}
        </Section.Query>
      )}
    </LocalProvider>
  );
}

function ContentHandler({ basepath }) {
  return (
    <Switch>
      <Route path={`${basepath}/remove`} component={RemoveRoute.Content} />
      <Route path={`${basepath}/edit`} component={EditRoute.Content} />
      <Route path={`${basepath}`} component={ViewRoute.Content} />
    </Switch>
  );
}

export function Indice(props) {
  return (
    <LocalProvider {...props}>
      {({ base, basepath, params: { packId } }) => (
        <>
          {/* A pack's id IS its name, like a section's — no useCrumbLabel, and
              no query per navigation to render what is already in the URL. */}
          <Crumb to={`${base}`} label={packId} />

          <Switch>
            <Route path={`${basepath}/remove`} component={RemoveRoute.Indice} />
            <Route path={`${basepath}/edit`} component={EditRoute.Indice} />
            <Route path={`${basepath}`} component={ViewRoute.Indice} />
          </Switch>
        </>
      )}
    </LocalProvider>
  );
}

export const Sidebar = () => (
  <>
    <EditRoute.Sidebar />
    <ViewRoute.Sidebar />
  </>
);
